module.exports = __webpack_public_path__ + "img/574-42dfb3.png";